
















import {Component, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import ImageShow from "@/components/ImageShow.vue";
import Select35 from "@/components/inputs/Select35.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import Dates from "@/components/inputs/dates.vue";

export class splash {
    targetUrl:string="";
    title : number = 0;
    endDate : string = "";
    description : boolean = true;
    enabled : boolean = false;
    cookieTime:number = 60;
    delay:number = 60;
    imageFile!:File;
    splash : string = "splash.png";

}
@Component({
    components: {
        Dates,
        ImageUpload,
        Select35,
        ImageShow,
        EnabledSwitch,
        EForm,Number,TextField
    }
})
export default class Splash extends  Vue{
    action : string = "config/splash";
    data : splash = new splash();
    async get(){
        let response = await this.$http.get(this.action);
        this.data = response.data;
    }
    async created(){
        await this.get();
    }
    changeStartTime(value:any){
        this.data.endDate = value;
    }
};
